(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var dialog = document.querySelector("[data-option-info-dialog]");
    if (!dialog || typeof dialog.showModal !== "function") return;

    var titleEl = dialog.querySelector("[data-option-info-title]");
    var bodyEl = dialog.querySelector("[data-option-info-body]");
    var lastTrigger = null;
    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function contentTemplate(key) {
      return document.querySelector('[data-option-info-content="' + key + '"]');
    }

    function openFor(trigger) {
      var key = trigger.getAttribute("data-option-info");
      var tpl = contentTemplate(key);
      if (!tpl || !titleEl || !bodyEl) return;

      lastTrigger = trigger;
      titleEl.textContent = tpl.getAttribute("data-option-info-title") || "Guidance";
      titleEl.hidden = false;
      bodyEl.innerHTML = tpl.innerHTML;

      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.classList.add("option-info-lock");
      }

      var closeBtn = dialog.querySelector(".option-info-dialog__close");
      (closeBtn || titleEl).focus();
    }

    function closeDialog() {
      if (!dialog.open) return;
      dialog.close();
    }

    dialog.addEventListener("close", function () {
      document.documentElement.classList.remove("option-info-lock");
      bodyEl.innerHTML = "";
      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
      }
      lastTrigger = null;
    });

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });

    dialog.querySelectorAll("[data-option-info-close]").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        closeDialog();
      });
    });

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-option-info]");
      if (!trigger) return;
      event.preventDefault();
      openFor(trigger);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || !dialog.open) return;
      // Native <dialog> also closes on Esc; ensure lock class clears via close event.
      if (reducedMotion) closeDialog();
    });
  });
})();
